import React, {Component} from 'react';
import '../style/newSolicitorForm.css';
import Dots from 'react-activity/lib/Dots';
import '../style/dots.css';
import FormResponseMessage from "./formResponseMessage";
import ValidationMessage from "./validationMessage";
import SolicitorGroupHOC from "../containers/SolicitorGroups/solicitorGroupHOC"
import Button from "./button";
import ReactDOM from 'react-dom';
import CenteredDots from "./General/centeredDots";
import {NavLink} from "react-router-dom";
import moment from "moment";
import CustomCheckbox from "./General/customCheckbox";
import FormGroupSelectMultiple from "./formGroupSelectMultiple";
import CustomModal from "./General/customModal";
import { LEGAL_ADVICE_TEXT } from '../helpers/variables';
import { formatSolicitorOptionLabel } from '../helpers/functions';
import CONTENT_STRINGS from '../helpers/contentStrings';
import infoIcon from '../info.svg';
import { FormGroup } from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS } from '../helpers/formGroupVariants';

class NewSolicitorForm extends Component {
    constructor(props) {
        super(props);
        this.setFocus = this.setFocus.bind(this);

    }


    setFocus = () => {
        // Explicitly focus the text input using the raw DOM API
        this.selectInput.focus();
        this.selectInput.click();
    };

    componentDidUpdate(prevProps, prevState) {
        if ((prevProps.NewSolicitor.posting && !this.props.NewSolicitor.posting)
            || (!prevProps.NewSolicitor.badResponse && this.props.NewSolicitor.badResponse)
        ) {
            ReactDOM.findDOMNode(this).scrollIntoView();
        }

    }

    
    render() {
        const {onUnlockUser} = this.props;
        const groupOptions = [{
            value: '',
            label: CONTENT_STRINGS.NONE
            }, ...this.props.NewSolicitor.solicitorGroups.map(item => {
            return {value: item.id, label: item.name, aragProvider: item.aragProvider}
        })];

        return (
            
            <div className="row">
                <div className="col-xs-12">
                    {
                        <CustomModal
                            isOpen={this.props.NewSolicitor.openModal}
                            handleClose={() => this.props.changeNewSolFormSettings('openModal', false)}
                            content= {<SolicitorGroupHOC />}
                            contentClassname={"solicitorGroupList-modal"}
/>
                    }
                    <h2 className="solicitor-form-title">{this.props.router.location.pathname.includes('/solicitors/edit-solicitor') ? `Edit ${LEGAL_ADVICE_TEXT} User` : `Create ${LEGAL_ADVICE_TEXT} User`}
                    </h2>
                    <div className="row solicitor-form-wrapper">
                        <form className="col-xs-11 form-horizontal" onSubmit={this.props.HandleSubmit}>
                            <div className="form-group">
                                <div className="col-xs-3">
                                    <Button wrapper={"btn-wrapper"}
                                            clickHandler={() => this.props.changeNewSolFormSettings('openModal', true)}
                                            btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'}
                                            label={`Create New ${LEGAL_ADVICE_TEXT} Group`}/>
                                </div>
                                <div className="col-xs-7">
                                    {
                                        this.props.NewSolicitor.responseMsg !== '' ?
                                            <div className="solicitor-form-message-success">
                                                {this.props.NewSolicitor.responseMsg}
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.props.NewSolicitor.badResponse !== '' ?
                                            <div className="solicitor-form-message-reject">
                                                {this.props.NewSolicitor.badResponse}
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                            </div>
                            {this.props.NewSolicitor.unlockErrorMessage && (
                                <FormResponseMessage
                                    Message={this.props.NewSolicitor.unlockErrorMessage}
                                    CenterWrapper="col-sm-12"
                                    MessageStyle="formResponseMessage-reject"
                                />
                            )}
                            <div className={"form-group"}>
                                <div className={"col-sm-12"}>
                                    <Button
                                        wrapper={"btn-wrapper"}
                                        clickHandler={onUnlockUser}
                                        btnType="button"
                                        btnStyle={'btn btn-primary btn-xs sharp blue'}
                                        label="Unlock User"
                                        disabled={!(this.props.NewSolicitor.newSolicitorFormData.isLockedOutUntilUtc
                                            && moment().isBefore(moment.utc(this.props.NewSolicitor.newSolicitorFormData.isLockedOutUntilUtc).local()))}
                                    />
                                    {this.props.NewSolicitor.newSolicitorFormData.isLockedOutUntilUtc
                                    && moment().isBefore(moment.utc(this.props.NewSolicitor.newSolicitorFormData.isLockedOutUntilUtc).local()) &&
                                    <span>
                                        {`Locked until ${moment.utc(this.props.NewSolicitor.newSolicitorFormData.isLockedOutUntilUtc).local().format("DD/MM/YYYY HH:mm:ss")}`}
                                        {this.props.NewSolicitor.unlockingUser && (
                                            [
                                                " ",
                                                <Dots/>
                                            ]
                                        )}
                                    </span>}
                                </div>
                            </div>
                            <FormGroup 
                                labelSize={"col-xs-3"}
                                inputSize={"col-xs-7"}
                                label={`${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.FIRM} *`}
                                variant={FORM_GROUP_VARIANTS.SEARCHABLE_LIST}
                                errorMessage={this.props.NewSolicitor.notValidSolicitor}
                                inputProps={{
                                    inputValue: this.props.lawsysFirms.suggestionFieldValue,
                                    onInputChange: this.props.onSuggestionChange,
                                    onChange: (value) => this.props.onSuggestionSelected(value),
                                    instanceId: 'solicitor',
                                    value: this.props.lawsysFirms.selectedLawsysFirmsDropdown.length > 0
                                        ? this.props.lawsysFirms.selectedLawsysFirmsDropdown.map(l => ({value: l.id, label: l.name, aragProvider: l.aragProvider}))[0]
                                        : null,
                                    options: this.props.lawsysFirms.lawsysFirmsFiltered.map(l => ({value: l.id, label: l.name, aragProvider: l.aragProvider})),
                                    isLoading: this.props.lawsysFirms.fetching,
                                    placeholder: CONTENT_STRINGS.TYPE_AT_LEAST_3_LETTERS,
                                    noOptionsText: `${CONTENT_STRINGS.NO} ${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.FIRM} ${CONTENT_STRINGS.FOUND}`,
                                    minSearchCharacters: 3,
                                    isMulti: false,
                                    formatOptionLabel: formatSolicitorOptionLabel,
                                }}
                            />
                            {
                                this.props.SolicitorGroup.fetchingSolicitorGroupById
                                    ? 
                                    <div style={{marginLeft: '400px'}}>
                                        <Dots/>
                                    </div>
                                    :
                                    this.props.NewSolicitor.shouldRenderGroupSelect 
                                    ?
                                        <div>
                                            <FormGroup
                                                labelSize={"col-xs-3"}
                                                inputSize={"col-xs-7"}
                                                label={`${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.GROUP}`}
                                                variant={FORM_GROUP_VARIANTS.SEARCHABLE_LIST}
                                                inputProps={{
                                                    id: 'selectedGroup',
                                                    instanceId: 'selectedGroup',
                                                    options: groupOptions,
                                                    // selectedGroup is stored/compared as a string elsewhere (see
                                                    // newSolicitorFormHOC.js's item.id.toString() === selectedGroup
                                                    // lookup) - option.value here is a number for real groups, so both
                                                    // directions need an explicit toString() to keep that contract.
                                                    onChange: (option) => this.props.changeNewSolFormSettings('selectedGroup', option ? option.value.toString() : ''),
                                                    value: groupOptions.find(o => o.value.toString() === this.props.NewSolicitor.selectedGroup) || null,
                                                    formatOptionLabel: formatSolicitorOptionLabel,
                                                }}
                                            />
                                            <div className="form-group">
                                                <div className="col-xs-3"></div>
                                                <div className="col-xs-7">
                                                    <Button
                                                        wrapper="btn-wrapper"
                                                        btnType="button"
                                                        clickHandler={() => this.props.setGroupOfSolicitor()}
                                                        btnStyle={'btn btn-primary btn-xs sharp white'}
                                                        label={`Attach ${LEGAL_ADVICE_TEXT}`}
                                                    />
                                                    {this.props.NewSolicitor.patchingGroup ?
                                                        <Dots/>
                                                        :
                                                        null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    :
                                    <div className="form-group">
                                        <div className="col-xs-3">
                                            <label className="control-label.text-left solicitor-form-labels">{LEGAL_ADVICE_TEXT} Group</label>
                                        </div>
                                        <div className="col-xs-7 formGroupSelectInput-select-wrapper">
                                            <ul className="solicitor-form">
                                                <li>
                                                    <NavLink id="groups"
                                                            to={"/solicitors/solicitor-groups/edit-solicitor-group/" +
                                                            this.props.NewSolicitor.newSolicitorFormData.solicitorGroupId}>
                                                        {/* The profile shows the group's own
                                                            ARAG Provider indicator next to its name. */}
                                                        {formatSolicitorOptionLabel({
                                                            label: this.props.NewSolicitor.newSolicitorFormData.solicitorGroupName,
                                                            aragProvider: this.props.NewSolicitor.newSolicitorFormData.solicitorGroupAragProvider,
                                                        })}
                                                    </NavLink>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    

                            }
                            <div className="form-group">
                                <div className="col-xs-3">
                                    <label
                                        className="control-label.text-left solicitor-form-labels">Forename<span
                                        className="solicitor-form-input-required">*</span></label>
                                </div>
                                <div className="col-xs-7 formGroupSelectInput-select-wrapper">
                                    <input type="text" className="form-control solicitor-form-inputs"
                                           name="forename"
                                           required={true}
                                           value={this.props.NewSolicitor.newSolicitorFormData.forename}
                                           onChange={(evt) => this.props.HandleNewSolicitor(evt.target.name, evt.target.value)}/>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-xs-3">
                                    <label
                                        className="control-label.text-left solicitor-form-labels">Surname<span
                                        className="solicitor-form-input-required">*</span></label>
                                </div>
                                <div className="col-xs-7 formGroupSelectInput-select-wrapper">
                                    <input type="text" className="form-control solicitor-form-inputs" name="surname"
                                           required={true}
                                           value={this.props.NewSolicitor.newSolicitorFormData.surname}
                                           onChange={(evt) => this.props.HandleNewSolicitor(evt.target.name, evt.target.value)}/>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-xs-3">
                                    <label className="control-label.text-left solicitor-form-labels">
                                        Email Address
                                        <span className="solicitor-form-input-required">*</span>
                                    </label>
                                </div>
                                <div
                                    className="col-xs-7 formGroupSelectInput-select-wrapper solicitor-form-info-input-wrapper">
                                    {(!this.props.NewSolicitor.solicitorForm.emailValidationError && (this.props.NewSolicitor.notValidEmail === '')) ?
                                        <div>
                                            <input type="text"
                                                   className="form-control solicitor-form-inputs solicitor-form-info-input-element"
                                                   required={true}
                                                   name="solicitorsEmailAddress"
                                                   value={this.props.NewSolicitor.newSolicitorFormData.solicitorsEmailAddress}
                                                   onChange={(evt) => this.props.HandleNewSolicitor(evt.target.name, evt.target.value)}/>
                                        </div>
                                        :
                                        <div>
                                            <input type="text"
                                                   className="form-control solicitor-form-inputs-error solicitor-form-info-input-element"
                                                   required={true}
                                                   name="solicitorsEmailAddress"
                                                   value={this.props.NewSolicitor.newSolicitorFormData.solicitorsEmailAddress}
                                                   onChange={(evt) => this.props.HandleNewSolicitor(evt.target.name, evt.target.value)}/>

                                            {
                                                (this.props.NewSolicitor.notValidEmail !== '') ?
                                                    <ValidationMessage
                                                        Label={this.props.NewSolicitor.notValidEmail}/>
                                                    :
                                                    null
                                            }
                                        </div>
                                    }
                                    {!this.props.NewSolicitor.solicitorForm.emailValidationError ?
                                        null
                                        :
                                        <div className="solicitor-form-arrow_box solicitor-form-reject-size-1">
                                            <div className="solicitor-form-arrow_box-text">A unique and valid email
                                                address
                                                is required
                                            </div>
                                        </div>
                                    }

                                </div>
                                <div className="col-xs-2">
                                    <img
                                        className="solicitor-form-input-info solicitor-form-info-input-element"
                                        src={infoIcon}
                                        onMouseOver={() => this.props.DisplaySolicitorFormEmailInfo()}
                                        onMouseLeave={() => this.props.DisplaySolicitorFormEmailInfo()}/>
                                    {
                                        this.props.NewSolicitor.solicitorForm.emailInfoAppear ?
                                            <div className="solicitor-form-info-box solicitor-form-reject-size-1">
                                                <div className="solicitor-form-arrow_box-text">Email
                                                    should
                                                    be
                                                    unique
                                                </div>
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-xs-3">
                                    <label className="control-label.text-left solicitor-form-labels">CC Email
                                    Address</label>
                                </div>
                                <div className="col-xs-7 formGroupSelectInput-select-wrapper">
                                    <input type="text" className={"form-control" + ' ' +
                                    (this.props.NewSolicitor.notValidEmailCC ? 'solicitor-form-inputs-error' : 'solicitor-form-inputs')}
                                           name="ccEmailAddress"
                                           value={this.props.NewSolicitor.newSolicitorFormData.ccEmailAddress}
                                           onChange={(evt) => this.props.HandleNewSolicitor(evt.target.name, evt.target.value)}/>
                                    {
                                        this.props.NewSolicitor.notValidEmailCC ?
                                            <ValidationMessage Label={this.props.NewSolicitor.notValidEmailCC}/>
                                            :
                                            null

                                    }
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-xs-3">
                                    <label
                                        className="control-label.text-left solicitor-form-labels">Username<span
                                        className="solicitor-form-input-required">*</span></label>
                                </div>
                                <div
                                    className="col-xs-7 formGroupSelectInput-select-wrapper solicitor-form-info-input-wrapper">
                                    {!this.props.NewSolicitor.solicitorForm.usernameValidationError ?
                                        <input type="text"
                                               disabled={this.props.router.location.pathname.includes('/solicitors/edit-solicitor')}
                                               className="form-control solicitor-form-inputs solicitor-form-info-input-element"
                                               value={this.props.NewSolicitor.newSolicitorFormData.userName}
                                               name="userName"
                                               required={true}
                                               onChange={(evt) => this.props.HandleNewSolicitor(evt.target.name, evt.target.value)}
                                        />
                                        :
                                        <input type="text"
                                               className="form-control solicitor-form-inputs-error solicitor-form-info-input-element"
                                               value={this.props.NewSolicitor.newSolicitorFormData.userName}
                                               name="userName"
                                               required={true}
                                               onChange={(evt) => this.props.HandleNewSolicitor(evt.target.name, evt.target.value)}
                                        />
                                    }
                                    {!this.props.NewSolicitor.solicitorForm.usernameValidationError ?
                                        null
                                        :
                                        <div className="solicitor-form-arrow_box solicitor-form-reject-size-2">
                                            <div className="solicitor-form-arrow_box-text">A unique username is
                                                required
                                            </div>
                                        </div>
                                    }

                                </div>
                                <div className="col-xs-2">
                                    <img className="solicitor-form-input-info solicitor-form-info-input-element"
                                         onMouseOver={() => this.props.DisplaySolicitorFormUsernameInfo()}
                                         onMouseLeave={() => this.props.DisplaySolicitorFormUsernameInfo()}
                                         src={infoIcon}/>
                                    {
                                        this.props.NewSolicitor.solicitorForm.usernameInfoAppear ?
                                            <div className="solicitor-form-info-box solicitor-form-reject-size-1">
                                                <div className="solicitor-form-arrow_box-text">Username should be
                                                    unique
                                                </div>
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                            </div>
                            {this.props.router.location.pathname.includes('/solicitors/edit-solicitor') ?
                                <div className="form-group">
                                    <div className="col-xs-3"><label className="control-label.text-left solicitor-form-labels"></label></div>
                                    <div className="col-xs-7 formGroupSelectInput-select-wrapper">

                                        <Button
                                            wrapper="btn-wrapper-forForms"
                                            btnType="button"
                                            clickHandler={(evt) => {
                                                evt.preventDefault();
                                                this.props.sendResetPasswordEmail({userId: this.props.NewSolicitor.selectedUserId})
                                            }}
                                            btnStyle={'btn btn-primary btn-xs sharp white'}
                                            label="Reset Password"
                                        />
                                        {this.props.NewSolicitor.sendingResetPasswordEmail ?
                                            <Dots/>
                                            :
                                            null
                                        }
                                        {this.props.NewSolicitor.sentRestPasswordEmailErrorMsg !== '' ?
                                            <FormResponseMessage
                                                Message={this.props.NewSolicitor.sentRestPasswordEmailErrorMsg}
                                                CenterWrapper="col-xs-12"
                                                MessageStyle="formResponseMessage-reject"/>
                                            :
                                            null}

                                        {this.props.NewSolicitor.sentRestPasswordEmailRespMsg !== '' ?
                                            <FormResponseMessage
                                                Message={this.props.NewSolicitor.sentRestPasswordEmailRespMsg}
                                                CenterWrapper="col-xs-12"
                                                MessageStyle="formResponseMessage-success"/>
                                            : null

                                        }

                                    </div>
                                </div>
                                : null
                            }
                            <div className="form-group">
                                <div className="col-xs-3"><label
                                    className="control-label.text-left solicitor-form-labels">Address</label></div>
                                <div className="col-xs-7 formGroupSelectInput-select-wrapper">
                                    <ul className="solicitor-form">
                                        <li>
                                            {this.props.NewSolicitor.newSolicitorFormData.addressLine1}
                                        </li>
                                        <li>
                                            {this.props.NewSolicitor.newSolicitorFormData.postcode}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-xs-3"><label className="control-label.text-left solicitor-form-labels">Telephone
                                    Number
                                    1</label>
                                </div>
                                <div className="col-xs-7 formGroupSelectInput-select-wrapper">
                                    <input type="text" className={"form-control" + ' ' +
                                    (this.props.NewSolicitor.notValidTel1 ? 'solicitor-form-inputs-error' : 'solicitor-form-inputs')
                                    }
                                           value={this.props.NewSolicitor.newSolicitorFormData.telephoneNumber1}
                                           name="telephoneNumber1"
                                           onChange={(evt) => this.props.HandleNewSolicitor(evt.target.name, evt.target.value)}
                                    />
                                    {
                                        this.props.NewSolicitor.notValidTel1 ?
                                            <ValidationMessage Label={this.props.NewSolicitor.notValidTel1}/>
                                            :
                                            null

                                    }
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-xs-3"><label className="control-label.text-left solicitor-form-labels">Telephone
                                    Number 1
                                    Description</label>
                                </div>
                                <div className="col-xs-7 formGroupSelectInput-select-wrapper">
                                    <input type="text" className="form-control solicitor-form-inputs"
                                           value={this.props.NewSolicitor.newSolicitorFormData.telephoneNumber1Description}
                                           name="telephoneNumber1Description"
                                           onChange={(evt) => this.props.HandleNewSolicitor(evt.target.name, evt.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-xs-3"><label className="control-label.text-left solicitor-form-labels">Telephone
                                    Number
                                    2</label>
                                </div>
                                <div className="col-xs-7 formGroupSelectInput-select-wrapper">
                                    <input type="text" className={"form-control" + ' ' +
                                    (this.props.NewSolicitor.notValidTel2 ? 'solicitor-form-inputs-error' : 'solicitor-form-inputs')}
                                           name="telephoneNumber2"
                                           value={this.props.NewSolicitor.newSolicitorFormData.telephoneNumber2}
                                           onChange={(evt) => this.props.HandleNewSolicitor(evt.target.name, evt.target.value)}
                                    />
                                    {
                                        this.props.NewSolicitor.notValidTel2 ?
                                            <ValidationMessage Label={this.props.NewSolicitor.notValidTel2}/>
                                            :
                                            null
                                    }
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-xs-3"><label className="control-label.text-left solicitor-form-labels">Telephone
                                    Number 2
                                    Description</label>
                                </div>
                                <div
                                    className="col-xs-7 formGroupSelectInput-select-wrapper solicitor-form-info-input-wrapper">
                                    <input type="text"
                                           className="form-control solicitor-form-inputs solicitor-form-info-input-element"
                                           name="telephoneNumber2Description"
                                           value={this.props.NewSolicitor.newSolicitorFormData.telephoneNumber2Description}
                                           onChange={(evt) => this.props.HandleNewSolicitor(evt.target.name, evt.target.value)}
                                    />
                                </div>
                            </div>
                            <hr className="generalTab-hr"/>
                            <CustomCheckbox
                                name="advancedDisbursementsChecked"
                                label="Allow to apply for Advance Disbursements"
                                _onChange={this.props._handleAdvancedDisbursementsCheckBoxes}
                                checked={this.props.NewSolicitor.newSolicitorFormData.advancedDisbursementsChecked}
                                disabled={!this.props.SolicitorGroup.advancedDisbursementsFormData.shouldBeAbleToApply}
                            />
                            {this.props.SolicitorGroup.advancedDisbursementsFormData.selectedCaseTypes.length > 0 ?
                                <FormGroupSelectMultiple
                                    disabled={!this.props.SolicitorGroup.advancedDisbursementsFormData.shouldBeAbleToApply ||
                                    !this.props.NewSolicitor.newSolicitorFormData.advancedDisbursementsChecked}
                                    Name="advancedDisbursementsSelectedCaseTypesSolicitor"
                                    HandleCheckedState={this.props._handleAdvancedDisbursementsCheckedCaseTypes}
                                    HandleInputChange={this.props._handleAdvancedDisbursementsMultipleCaseTypes}
                                    Label="Case Types"
                                    Required={false}
                                    Options={this.props.SolicitorGroup.advancedDisbursementsFormData.selectedCaseTypes.map(item => {
                                        return {name: item.name, id: item.id}
                                    })}
                                    LeftWrapper="col-sm-3"
                                    CenterWrapper="col-sm-8 formGroupSelectInput-select-wrapper"
                                    RightWrapper=""
                                    InputWrapper="col-sm-8 formGroup-textInput-input-wrapper"
                                />
                                : null}
                            {this.props.subCases && this.props.subCases.length > 0 ?
                                <FormGroupSelectMultiple
                                    disabled={!this.props.SolicitorGroup.advancedDisbursementsFormData.shouldBeAbleToApply ||
                                    !this.props.NewSolicitor.newSolicitorFormData.advancedDisbursementsChecked}
                                    Name="advancedDisbursementsSelectedSubCaseTypesSolicitorCase"
                                    HandleCheckedState={this.props._handleAdCheckedSubCaseTypes}
                                    HandleInputChange={this.props._handleAdSelectedSubCaseTypes}
                                    Label="Sub Case Types"
                                    Required={false}
                                    Options={this.props.subCases.map(item => {
                                        return {name: item.name, id: item.id}
                                    })}
                                    LeftWrapper="col-sm-3"
                                    CenterWrapper="col-sm-8 formGroupSelectInput-select-wrapper"
                                    RightWrapper=""
                                    InputWrapper="col-sm-8 formGroup-textInput-input-wrapper"
                                />
                                : null}

                            <div className="form-group">
                                <div className="col-xs-3"><label className="control-label.text-left solicitor-form-labels">Do not allow
                                    new applications from this {LEGAL_ADVICE_TEXT}</label>
                                </div>
                                <div
                                    className="col-xs-7 formGroupSelectInput-select-wrapper solicitor-form-info-input-wrapper">
                                    <input
                                        id="checkboxAllowApps"
                                        type="checkbox"
                                        className="appFormRefSettings-check_box"
                                        checked={!this.props.NewSolicitor.newSolicitorFormData.allowedToCreateApplications}
                                        name="allowedToCreateApplications"
                                        onChange={(evt) => {
                                            this.props.HandleNewSolicitor(evt.target.name, !evt.target.checked)
                                        }}/>
                                    <label htmlFor="checkboxAllowApps"></label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-xs-3"><label className="control-label.text-left solicitor-form-labels">
                                    Allow user to access applications and policies made by other users from the same {LEGAL_ADVICE_TEXT.toLowerCase()}
                                    </label>
                                </div>
                                <div
                                    className="col-xs-7 formGroupSelectInput-select-wrapper solicitor-form-info-input-wrapper">
                                    <input
                                        id="allowedToSeeAllFirmApplications"
                                        type="checkbox"
                                        className="appFormRefSettings-check_box"
                                        checked={this.props.NewSolicitor.newSolicitorFormData.allowedToSeeAllFirmApplications}
                                        name="allowedToSeeAllFirmApplications"
                                        onChange={(evt) => {
                                            this.props.HandleNewSolicitor(evt.target.name, evt.target.checked)
                                        }}/>
                                    <label htmlFor="allowedToSeeAllFirmApplications"></label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-xs-3">
                                </div>
                                <div className="col-xs-7">
                                    <Button wrapper="btn-wrapper-forForms" btnType="submit"
                                            btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                            label={this.props.router.location.pathname.includes('/solicitors/edit-solicitor') ? 'Save Changes' : `Create ${LEGAL_ADVICE_TEXT} User`}/>
                                    <Button wrapper="btn-wrapper-forForms" btnType="button" clickHandler={() => {
                                        this.props.goBack()
                                    }} btnStyle={'btn btn-primary btn-xs sharp white'} label="Go Back"/>
                                </div>
                            </div>
                            {
                                this.props.NewSolicitor.posting ?
                                    <CenteredDots/>
                                    :
                                    null
                            }
                            {
                                this.props.lawsysFirms.fetchingLawsysFirmGroup ?
                                    <div className="text-center">
                                        <span>Searching Lawsys firm group</span>
                                        <br/>
                                        <Dots/>
                                    </div>
                                    :
                                    null
                            }
                            {
                                this.props.NewSolicitor.fetchingSolicitorGroups ?
                                    <div className="text-center">
                                        <span>Fetching {LEGAL_ADVICE_TEXT.toLowerCase()} groups</span>
                                        <br/>
                                        <Dots/>
                                    </div>
                                    :
                                    null
                            }
                        </form>
                    </div>
                </div>
            </div>

        )
    }
}

export default NewSolicitorForm;
